// Model payloads are large, so they load only once someone opens this.
export const ModelCallsDetails = ({
  modelCalls,
  modelCallLimit,
  isRequested,
  isLoading,
  onOpen,
}: {
  modelCalls: unknown[]
  modelCallLimit: number
  isRequested: boolean
  isLoading: boolean
  onOpen: () => void
}) => (
  <details
    className="border-t pt-4 text-sm"
    onToggle={(event) => {
      if (event.currentTarget.open) onOpen()
    }}
  >
    <summary className="font-semibold">
      Model calls and raw technical data
    </summary>
    {isRequested && (
      <div className="mt-3 space-y-2">
        {isLoading && (
          <p role="status" className="text-muted-foreground text-xs">
            Loading model calls…
          </p>
        )}
        <p className="text-muted-foreground text-xs">
          Shows up to {modelCallLimit} calls.
        </p>
        <pre className="bg-surface-base overflow-auto rounded-sm p-3 text-xs">
          {JSON.stringify(modelCalls, null, 2)}
        </pre>
      </div>
    )}
  </details>
)
